import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";

export const Spinner = ({ open = true }) => {
  return (
    <Backdrop
      sx={{
        paddingBottom: "100px",
        color: "#fff",
        backgroundColor: "rgb(0,0,0,0)",
        zIndex: 9999,
      }}
      open={open}
    >
      <CircularProgress />
    </Backdrop>
  );
};
